module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-cell"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Cell Swipe")]), _vm._v(" "), _vm._l((15), function(n) {
    return _c('mt-cell-swipe', {
      attrs: {
        "right": _vm.rightButtons,
        "title": "swipe me"
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5377547d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/cell-swipe.vue
// module id = 296
// module chunks = 0